import { ProblemError, type OutgoingDraft, type Part } from '@/model';

/** Ordinary send parts, shared by durable wire sends and their local timeline stand-ins. */
export function outgoingParts(draft: OutgoingDraft): Part[] {
  const parts: Part[] = draft.text ? [{ type: 'text', text: draft.text, format: draft.format ?? 'markdown' }] : [];
  for (const link of draft.links ?? []) {
    let url: URL;
    try { url = new URL(link.url); } catch { throw invalid(); }
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) throw invalid();
    parts.push({ type: 'link', url: link.url, title: link.title, description: link.description, image_media_id: link.image_media_id });
  }
  for (const card of draft.cards ?? []) {
    if (card.type === 'contact') parts.push({ type: 'contact', account_id: card.account_id });
    else if (card.type === 'location' && Number.isFinite(card.lat) && card.lat >= -90 && card.lat <= 90 && Number.isFinite(card.lng) && card.lng >= -180 && card.lng <= 180) parts.push({ type: 'location', lat: card.lat, lng: card.lng, name: card.name, address: card.address, snapshot_media_id: card.snapshot_media_id });
    else throw invalid();
  }
  if (parts.length + (draft.attachments?.length ?? 0) > 10) throw invalid();
  return parts;
}
function invalid() { return new ProblemError({ status: 400, code: 'invalid_request' }); }
